module.exports = __webpack_public_path__ + "img/taiwan.e2d2694a.svg";